import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { briefGetSession } from '@ghostwright/api-client';

export default function FinalisingState({ sessionId }: { sessionId: string }) {
  const navigate = useNavigate();

  useEffect(() => {
    const timer = setInterval(async () => {
      try {
        const session = await briefGetSession(sessionId);
        if (session.status === 'complete') {
          clearInterval(timer);
          navigate('/');
        } else if (session.status === 'failed') {
          clearInterval(timer);
          window.location.reload();
        }
      } catch {
        // Keep polling
      }
    }, 3000);
    return () => clearInterval(timer);
  }, [sessionId, navigate]);

  return (
    <div className="text-center py-20">
      <div className="inline-flex items-center gap-2 mb-6">
        <span className="w-2 h-2 rounded-full bg-primary animate-pulse" />
        <span className="w-2 h-2 rounded-full bg-primary animate-pulse [animation-delay:150ms]" />
        <span className="w-2 h-2 rounded-full bg-primary animate-pulse [animation-delay:300ms]" />
      </div>
      <h2 className="font-display text-2xl text-heading mb-3 [font-variation-settings:'opsz'_48,'SOFT'_60]">
        Your brief is being prepared.
      </h2>
      <p className="text-muted-foreground text-base leading-relaxed max-w-md mx-auto">
        The press is reviewing what we built together and preparing your artefact bundle. This usually takes under a minute.
      </p>
    </div>
  );
}
